module.exports = __webpack_public_path__ + "static/media/face-care.b6516434.png";